import { useEffect, useState } from 'react';
import { useWindowSize } from '@zg-rentals/react-hooks';

/**
 * @description Determines the current browser window width.
 * isMobileView (for browser widths < 1280px).
 * isDesktopView (for browser widths >= 1280px).
 * isMdAndBelow (for browser widths < 480px - aligns with Constellation MD breakpoint).
 * isMdAndUp (for browser widths >= 480px).
 *
 * Returns server-matching defaults (desktop) until after hydration to prevent
 * SSR hydration mismatches, since window dimensions are unavailable on the server.
 * @returns Object
 */
export default () => {
  const { width } = useWindowSize();
  const [hasMounted, setHasMounted] = useState(false);

  useEffect(() => setHasMounted(true), []);

  // Before mount, match server defaults (Infinity width from react-use)
  // so that SSR and initial client render agree, preventing hydration errors.
  if (!hasMounted) {
    return {
      isMobileView: false,
      isDesktopView: true,
      isMdAndBelow: false,
      isMdAndUp: true,
      isWindowWidthSet: false,
    };
  }

  return {
    isMobileView: width > 0 && width < 1280,
    isDesktopView: width >= 1280,
    isMdAndBelow: width > 0 && width < 480,
    isMdAndUp: width >= 480,
    isWindowWidthSet: width !== 0,
  };
};
